<template>
  <div style="width: 100%;height: 100%;overflow:auto;">
    <div style="display: flex;margin-left: 10px;margin-top: 10px;">
      <div style="width: 300px;font-size: 18px"><b>年度收款数据：</b></div>
      <el-select v-model="yearReceiveCompany" style="width: 150px;" @change="initYearPaymentData">
        <el-option v-for="item in companyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="yearReceiveYear" style="width: 150px;margin-left: 10px" @change="initYearPaymentData">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label + '年度'" :value="item.value"></el-option>
      </el-select>

      <div class="dimension_cnt" :style="yearCntStyle" @click="getDimensionCntInfo('year')">
        笔数
      </div>
      <div class="dimension_amount" :style="yearAmountStyle" @click="getDimensionAmountInfo('year')">
        金额
      </div>

    </div>
    <div style="width: 98%;height: 300px;" id="yearPayment"></div>

    <div style="display: flex;margin-left: 10px;margin-top: 10px;">
      <div style="width: 300px;font-size: 18px"><b>月度收款数据：</b></div>
      <el-select v-model="monthReceiveCompany" style="width: 150px;" @change="initMonthPaymentData">
        <el-option v-for="item in companyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="monthReceiveYear" style="width: 150px;margin-left: 10px" @change="initMonthPaymentData">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label + '年度'" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="monthReceiveMonth" style="width: 150px;margin-left: 10px" @change="initMonthPaymentData">
        <el-option v-for="item in 12" :key="item + ''" :label="item + '月'" :value="item + ''"></el-option>
      </el-select>

      <div class="dimension_cnt" :style="monthCntStyle" @click="getDimensionCntInfo('month')">
        笔数
      </div>
      <div class="dimension_amount" :style="monthAmountStyle" @click="getDimensionAmountInfo('month')">
        金额
      </div>

    </div>
    <div style="width: 98%;height: 300px;" id="monthPayment"></div>


    <div style="display: flex;margin-left: 10px;margin-top: 10px;">
      <div style="width: 300px;font-size: 18px"><b>员工月度收款数据：</b></div>
      <el-select v-model="employeeReceiveTeam" style="width: 200px;" @change="initEmployeePaymentData">
        <el-option v-for="item in teamList" :label="item.label" :value="item.value" :key="item.value"></el-option>
      </el-select>
      <el-select v-model="employeeReceiveYear" style="width: 150px;margin-left: 10px" @change="initEmployeePaymentData">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label + '年度'" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="employeeReceiveMonth" style="width: 150px;margin-left: 10px" @change="initEmployeePaymentData">
        <el-option v-for="item in 12" :key="item + ''" :label="item + '月'" :value="item + ''"></el-option>
      </el-select>

      <div class="dimension_cnt" :style="employeeCntStyle" @click="getDimensionCntInfo('employee')">
        笔数
      </div>
      <div class="dimension_amount" :style="employeeAmountStyle" @click="getDimensionAmountInfo('employee')">
        金额
      </div>

    </div>
    <div style="width: 98%;height: 300px;" id="employeeMonthPayment"></div>






  </div>
</template>

<script>
import * as echarts from "echarts";
import dayjs from "dayjs";

export default {
  name: "ReceivePaymentData",

  data(){
    return{
      yearCntStyle:'',
      yearAmountStyle:'',
      monthCntStyle:'',
      monthAmountStyle:'',
      employeeCntStyle:'',
      employeeAmountStyle:'',
      companyList:[],
      yearList:[],
      teamList:[],
      yearReceiveCompany:'summaryData',
      yearReceiveYear:'',
      monthReceiveCompany:'summaryData',
      monthReceiveYear:'',
      monthReceiveMonth:'1',
      employeeReceiveTeam:'',
      employeeReceiveYear:'',
      employeeReceiveMonth:'1',

      yearPaymentSeriesData: [],

      monthPaymentSeriesData: [],
      monthPaymentXLengthData:[],

      employeePaymentSeriesData: [],
      employeePaymentXLengthData:[],


    }
  },
  async created() {
    await this.getDimensionAmountInfo('year');
    await this.getDimensionAmountInfo('month');
    await this.getDimensionAmountInfo('employee');
    await this.getYearList();
    await this.getCompanyList();
    await this.getAllTeam();
    await this.initYearPaymentData();
    await this.initMonthPaymentData();
    await this.initEmployeePaymentData();

  },

  methods:{

    async initYearPaymentData(){
      await this.getYearPaymentData();
      await this.renderEcharts();
    },
    async getYearPaymentData(){
      let params = {company:this.yearReceiveCompany,year:this.yearReceiveYear};
      let data = await this.$http('crmBusinessService.getYearPaymentData',params);
      if(this.yearCntStyle){
        this.yearPaymentSeriesData = data?.cntSeriesData;
      }else {
        this.yearPaymentSeriesData = data?.amountSeriesData;
      }
    },
    async initMonthPaymentData(){
      await this.getMonthPaymentData();
      await this.renderMonthPaymentEcharts();
    },
    async getMonthPaymentData() {
      let params = {company: this.monthReceiveCompany, year: this.monthReceiveYear, month: this.monthReceiveMonth};
      let data = await this.$http('crmBusinessService.getMonthPaymentData', params);
      this.monthPaymentXLengthData = data?.xLengthData;
      if(this.monthCntStyle){
        this.monthPaymentSeriesData = data?.cntSeriesData;
      }else {
        this.monthPaymentSeriesData = data?.amountSeriesData;
      }

    },

    async initEmployeePaymentData(){
      await this.getEmployeePaymentData();
      await this.renderEmployeeMonthEcharts();
    },
    async getEmployeePaymentData() {
      let params = {team: this.employeeReceiveTeam, year: this.employeeReceiveYear, month: this.employeeReceiveMonth};
      let data = await this.$http('crmBusinessService.getEmployeePaymentData', params);
      this.employeePaymentXLengthData = data?.xLengthData;
      if(this.employeeCntStyle){
        this.employeePaymentSeriesData = data?.cntSeriesData;
      }else {
        this.employeePaymentSeriesData = data?.amountSeriesData;
      }
    },


    async getYearList(){
      const now = dayjs();
      this.yearReceiveYear = now.year() + '';
      this.monthReceiveYear = now.year() + '';
      this.employeeReceiveYear = now.year() + '';
      this.yearList = await this.$http('sysDsService.getYears(10,1)')
    },
    async getCompanyList(){
      let data = await this.$http('crmTeamService.getCompanyList');
      data.unshift({value:'summaryData',label:'汇总数据'})
      this.companyList = data;
    },
    async getAllTeam(){
      let data = await this.$http('crmTeamService.getAllTeam');
      data.unshift({value:'allTeam',label:'全部'})
      this.teamList = data;
      if(this.teamList){
        this.employeeReceiveTeam = this.teamList[0].value;
      }
    },

    renderEcharts(){

      const yearPaymentChartDom = document.getElementById('yearPayment');

      // 获取现有的 ECharts 实例（如果有）
      let yearPaymentChart = echarts.getInstanceByDom(yearPaymentChartDom);

      // 如果存在现有的实例，销毁它
      if (yearPaymentChart) {
        yearPaymentChart.dispose();
      }

      // 初始化新的 ECharts 实例
      yearPaymentChart = echarts.init(yearPaymentChartDom);
      yearPaymentChart.setOption(this.getYearPaymentChartOptions(), true);
    },
    getYearPaymentChartOptions(){
      let type = '';
      if(this.yearCntStyle) {
        type = '笔数';
      }else {
        type = '金额';
      }
      return{
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let tooltipHtml = '';
            // 获取 X 轴数据（假设 params[0] 存在）
            const xAxisValue = params[0].axisValue; // X 轴的值，例如 "1月"
            tooltipHtml += `<b>${xAxisValue}</b><br>`; // 第一行显示 X 轴数据

            params.forEach(param => {
              if (param.seriesType === 'line') {
                tooltipHtml += `${param.marker} ${param.seriesName}<span style="float: right;margin-left: 10px"><b>${param.value}%</b></span><br>`;
              } else if (param.seriesType === 'bar') {
                tooltipHtml += `${param.marker} ${param.seriesName}<span style="float: right;margin-left: 10px"><b>${param.value}</b></span><br>`;
              }
            });
            return tooltipHtml;
          }
        },
        legend: {
          top: '10px',
        },
        xAxis: [
          {
            type: 'category',
            data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: type,
            alignTicks:true
          },
          {
            type: 'value',
            name: '比例',
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        series:this.yearPaymentSeriesData === undefined ? [] : this.yearPaymentSeriesData,
      }
    },
    renderMonthPaymentEcharts(){

      const yearPaymentChartDom = document.getElementById('monthPayment');

      // 获取现有的 ECharts 实例（如果有）
      let yearPaymentChart = echarts.getInstanceByDom(yearPaymentChartDom);

      // 如果存在现有的实例，销毁它
      if (yearPaymentChart) {
        yearPaymentChart.dispose();
      }

      // 初始化新的 ECharts 实例
      yearPaymentChart = echarts.init(yearPaymentChartDom);
      yearPaymentChart.setOption(this.getMonthPaymentChartOptions(), true);
    },
    getMonthPaymentChartOptions(){
      let type = '';
      if(this.monthCntStyle) {
        type = '笔数';
      }else {
        type = '金额';
      }
      return{
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          top: '10px',
          data: ['待收款', '已收款', '比例']
        },
        xAxis: [
          {
            type: 'category',
            data: this.monthPaymentXLengthData === undefined ? [] : this.monthPaymentXLengthData,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: type,
            alignTicks:true
          },
          {
            type: 'value',
            name: '比例',
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        series:this.monthPaymentSeriesData === undefined ? [] : this.monthPaymentSeriesData,
      }
    },
    renderEmployeeMonthEcharts(){

      const yearPaymentChartDom = document.getElementById('employeeMonthPayment');

      // 获取现有的 ECharts 实例（如果有）
      let yearPaymentChart = echarts.getInstanceByDom(yearPaymentChartDom);

      // 如果存在现有的实例，销毁它
      if (yearPaymentChart) {
        yearPaymentChart.dispose();
      }

      // 初始化新的 ECharts 实例
      yearPaymentChart = echarts.init(yearPaymentChartDom);
      yearPaymentChart.setOption(this.getEmployeePaymentChartOptions(), true);
    },
    getEmployeePaymentChartOptions(){
      let type = '';
      if(this.employeeCntStyle) {
        type = '笔数';
      }else {
        type = '金额';
      }
      return{
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          top: '10px',
          data: ['计划', '及时完成', '及时完成率']
        },
        xAxis: [
          {
            type: 'category',
            data: this.employeePaymentXLengthData === undefined ? [] : this.employeePaymentXLengthData,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: type,
            alignTicks:true
          },
          {
            type: 'value',
            name: '比例',
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        series: this.employeePaymentSeriesData === undefined ? [] : this.employeePaymentSeriesData,
      }
    },



    async getDimensionCntInfo(type){
      //先改渲染状态
      if(type === 'year'){
        if(this.yearAmountStyle){
          this.yearAmountStyle = '';
        }
        this.yearCntStyle = 'background: rgb(4,134,254);color:white';
        //显示逻辑
        await this.initYearPaymentData();
      }
      if(type === 'month'){
        if(this.monthAmountStyle){
          this.monthAmountStyle = '';
        }
        this.monthCntStyle = 'background: rgb(4,134,254);color:white';
        //显示逻辑
        await this.initMonthPaymentData();
      }
      if(type === 'employee'){
        if(this.employeeAmountStyle){
          this.employeeAmountStyle = '';
        }
        this.employeeCntStyle = 'background: rgb(4,134,254);color:white';
        //显示逻辑
        await this.initMonthPaymentData();
      }


    },
    async getDimensionAmountInfo(type){
      //先改渲染状态
      if(type === 'year'){
        if(this.yearCntStyle){
          this.yearCntStyle = '';
        }
        this.yearAmountStyle = 'background: rgb(4,134,254);color:white';
        //显示逻辑
        await this.initYearPaymentData();
      }
      if(type === 'month'){
        if(this.monthCntStyle){
          this.monthCntStyle = '';
        }
        this.monthAmountStyle = 'background: rgb(4,134,254);color:white';
        //显示逻辑
        await this.initMonthPaymentData();
      }
      if(type === 'employee'){
        if(this.employeeCntStyle){
          this.employeeCntStyle = '';
        }
        this.employeeAmountStyle = 'background: rgb(4,134,254);color:white';
        //显示逻辑
        await this.initMonthPaymentData();
      }


    }

  }
}
</script>

<style scoped>

.dimension_amount{
  width: 100px;
  line-height: 30px;
  border: 1px #cccccc solid;
  border-left: none;
  text-align: center;
  cursor: pointer
}

.dimension_cnt{
  width: 100px;
  line-height: 30px;
  margin-left: 20px;
  border: 1px #cccccc solid;
  text-align: center;
  cursor: pointer
}


</style>